import * as React from "react";
const SvgFiRrAlbumCollection = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-album-collection_svg__a)">
      <path
        fill="#062147"
        d="M19 24H5c-2.76 0-5-2.24-5-5v-6c0-2.76 2.24-5 5-5h14c2.76 0 5 2.24 5 5v6c0 2.76-2.24 5-5 5M5 10c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3v-6c0-1.65-1.35-3-3-3zm18.66-2.9c.41-.37.45-1 .09-1.41A5 5 0 0 0 20 4H4C2.57 4 1.2 4.62.25 5.69A.99.99 0 0 0 .34 7.1c.41.36 1.05.33 1.41-.09.57-.65 1.39-1.02 2.25-1.02h16c.86 0 1.68.37 2.25 1.02.2.22.47.34.75.34.23 0 .47-.08.66-.25m0-4c.41-.37.45-1 .09-1.41A5 5 0 0 0 20 0H4C2.57 0 1.2.62.25 1.69A.99.99 0 0 0 .34 3.1c.41.36 1.05.33 1.41-.09.57-.65 1.39-1.02 2.25-1.02h16c.86 0 1.68.37 2.25 1.02.2.22.47.34.75.34.23 0 .47-.08.66-.25M12 20c-3.98 0-8-1.37-8-4s4.02-4 8-4 8 1.37 8 4-4.02 4-8 4m0-6c-3.72 0-6 1.29-6 2s2.28 2 6 2 6-1.29 6-2-2.28-2-6-2m0 3c.83 0 1.5-.45 1.5-1s-.67-1-1.5-1-1.5.45-1.5 1 .67 1 1.5 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-album-collection_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlbumCollection;
